import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    ContentSection,
    Content,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import { durationToHoursAndMinutes } from 'wanderu-utils';

import placeGuideConfig from '../../../../config/placeguide.locale';

function RouteRow(props) {
    const {
        t,
        i18nMoment,
        i18nMoney,
        route = {},
    } = props;
    const {
        departCity,
        c2cUrl,
        averageTimeMin,
        averagePriceUsd,
    } = route;

    if (!averageTimeMin || !averagePriceUsd) {
        return null;
    }

    const averageTime = i18nMoment.duration(averageTimeMin, 'minutes');
    const averagePrice = i18nMoney(averagePriceUsd).format();

    const duration = durationToHoursAndMinutes(i18nMoment.duration(averageTime));
    let durationString = t('baseApp:trip-duration_hours', duration);
    if (duration.days > 0) {
        durationString = t('baseApp:trip-duration_days', duration);
    }

    return (
        <TableRow>
            <TableCell size="small">
                <A href={c2cUrl} native>
                    {departCity}
                </A>
            </TableCell>
            <Typography
                component={TableCell}
                componentProps={{
                    size: 'small',
                }}
            >
                {durationString}
            </Typography>
            <Typography
                component={TableCell}
                componentProps={{
                    size: 'small',
                }}
            >
                {averagePrice}
            </Typography>
        </TableRow>
    );
}

const LocalizedRouteRow = localize(RouteRow, placeGuideConfig.namespace);

function PopularRoutes(props) {
    const {
        t,
        className,
        c2cRoutes,
    } = props;

    if (!c2cRoutes.length) {
        return null;
    }

    const headerProps = {
        variant: 'head',
        size: 'small',
    };

    return (
        <ContentSection
            className={className}
            id="city-guide-popular-routes"
            title={t('popularRoutesTitle')}
            isCollapsable
            useAccordionComponent
        >
            <Content>
                <Table variant="blocks">
                    <TableHead>
                        <TableRow variant="head">
                            <Typography
                                component={TableCell}
                                componentProps={headerProps}
                            >
                                {t('routeTableHeader')}
                            </Typography>
                            <Typography
                                component={TableCell}
                                componentProps={headerProps}
                            >
                                {t('shortAvgTime')}
                            </Typography>
                            <Typography
                                component={TableCell}
                                componentProps={headerProps}
                            >
                                {t('shortAvgPrice')}
                            </Typography>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {c2cRoutes.map((route) => (
                            <LocalizedRouteRow
                                key={route.c2cUrl}
                                route={route}
                            />
                        ))}
                    </TableBody>
                </Table>
            </Content>
        </ContentSection>
    );
}

PopularRoutes.propTypes = {
    className: PropTypes.string,
    c2cRoutes: PropTypes.arrayOf(PropTypes.object),
};
PopularRoutes.defaultProps = {
    c2cRoutes: [],
};

export {
    PopularRoutes,
    RouteRow,
};

export default localize(PopularRoutes, placeGuideConfig.namespace);
